import * as api from "../../api/generated-api";
import { RouteComponentProps } from "react-router-dom";
import { updateCompanyLawFirmClient } from "../../api/company/company";
import { connect } from "react-redux";
import { configureAuthHeader, configureBaseUrl } from "../../api/axiosConfig";
import { clickToLinkHandler } from "../../helpers/utils";

type AcceptLawFirmClientRequestPageProps = RouteComponentProps<{
  companyOrgId?: string;
  lawFirmClientId?: string;
}> & {
  token: string;
};
const AcceptLawFirmClientRequestPage = (
  props: AcceptLawFirmClientRequestPageProps
) => {
  const companyOrgId = Number(props.match.params.companyOrgId);
  const lawFirmClientId = Number(props.match.params.lawFirmClientId);
  const token = props.token;

  configureBaseUrl();
  configureAuthHeader(token);

  updateCompanyLawFirmClient(
    companyOrgId,
    lawFirmClientId,
    { status: api.LawFirmClientStatus.accepted },
    () => {
      clickToLinkHandler(`/companies/${companyOrgId}`);
    }
  );

  return null;
};

const mapStateToProps = (state) => {
  const { token } = state.auth;

  return {
    token,
  };
};

export default connect(mapStateToProps)(AcceptLawFirmClientRequestPage);
